/**
 * Donors Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const donorsRoutes: RouteRecordRaw[] = [
  {
    path: '/donors',
    name: 'donors',
    component: () => import('./views/DonorsListView.vue'),
    meta: {
      title: () => i18next.t('nav.donors'),
      requiredEntitlement: 'DONOR_MANAGEMENT',
    },
  },
  {
    path: '/donors/:id',
    name: 'donor-profile',
    component: () => import('./views/DonorProfileOverview.vue'),
    meta: {
      title: () => i18next.t('donor.profilePageTitle'),
      requiredEntitlement: 'DONOR_MANAGEMENT',
      breadcrumbs: [
        { label: () => i18next.t('nav.donors'), to: '/donors' },
        { label: () => i18next.t('donor.profilePageTitle') },
      ],
    },
  },
];
